
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/partners/opt",
      function () {
        return require("private-next-pages/partners/opt/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/partners/opt"])
      });
    }
  